import { splitLtrRanges } from "../../utils/ticketTypeSelection";

/**
 * Renders text with numeric/time ranges isolated LTR (`<bdi dir="ltr">`), so "11:30–12:15" or
 * "3–4" inside Hebrew text don't render reversed.
 */
export const LtrRanges = ({ text }) => (
    <>
        {splitLtrRanges(text).map((part, i) => part.ltr ? <bdi key={i} dir="ltr">{part.text}</bdi> : <span key={i}>{part.text}</span>)}
    </>
)
